import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// Get these values from Firebase Console -> Project Settings -> General -> Your Apps -> SDK setup and configuration
const firebaseConfig = {
    apiKey: "AIzaSyAlyZuoZqZvDCTBSBsjdAQr0jrhHZNMl4g",
    authDomain: "odikai-main.firebaseapp.com",
    projectId: "odikai-main",
    storageBucket: "odikai-main.firebasestorage.app",
    messagingSenderId: "1067793967712",
    appId: "1:1067793967712:web:442acb1ab548ffe7feb105",
    measurementId: "G-1BMHBDXGH9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app); 